import axios from 'axios';
import Vue from 'vue';
import i18n from '../i18n/i18n';
import {
    Message
} from 'element-ui';
import store from '../store';

axios.defaults.timeout = 30000;           //超时时间
axios.defaults.retry = 0;                 //请求次数
axios.defaults.retryDelay = 1000;         //请求间隙

if (process.env.NODE_ENV === 'development') {
    //开发环境
    axios.defaults.baseURL = 'http://127.0.0.1:8082';
    axios.defaults.baseWS = 'ws://127.0.0.1:8082';
	// axios.defaults.baseURL = 'https://exchange-api-qa.rwa.ltd';
	// axios.defaults.baseWS = 'wss://exchange-api-qa.rwa.ltd';
} 
else if (process.env.NODE_ENV === 'test') {
    axios.defaults.baseURL = 'https://exchange-api-qa.rwa.ltd';
    axios.defaults.baseWS = 'wss://exchange-api-qa.rwa.ltd';
} 
// else if (process.env.NODE_ENV === 'test80') {
//     //80测试服务器
//     axios.defaults.baseURL = 'http://127.0.0.1:8081';
//     axios.defaults.baseWS = 'ws://127.0.0.1:8081';
// } 
else {
    //真实环境
    // axios.defaults.baseURL = window.location.origin + '/clientapi';
    // axios.defaults.baseWS = 'wss://'+window.location.host + '/clientapi';
    // // for dev
    // axios.defaults.baseURL = '/apx';
    // axios.defaults.baseWS = 'ws://' + window.location.host + '/wsapp';
	
	axios.defaults.baseURL = 'https://exchange-api.rwa.ltd';
	axios.defaults.baseWS = 'wss://exchange-api.rwa.ltd';
}

axios.interceptors.request.use(config => {
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    // window.localStorage.removeItem('jwt-token');
    if (window.localStorage.getItem('jwt-token') && config.url.indexOf('/user/signIn') < 0) {
        config.headers.Authorization = window.localStorage.getItem('jwt-token'); // 让每个请求携带token-- ['jwt-token']为自定义key
    } else {
        config.headers.Authorization = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.' +
            'eyJzdWIiOiJ1c2VyaWQiLCJhdWQiOiI5OTAwMDAwMCIsImlzcyI6IldUWiIsInVzZXJUeXBlI' +
            'joidmlzaXRvciIsImV4cCI6NDIyNjcxNzgyLCJpYXQiOjE1NjQwMzkwNzgsInVzZXJJZCI6OTkwMDAwMDAsImp0aSI6IjAwIn0.' +
            'XVBFfTMsGtMYCUhaeuKt9jYaQJRRC8UAvUTzeJDX5v4';//游客的H5 JWT
    }
    config.headers['X-Exchange-Info'] = 'language=' + i18n.locale + '&source=web&priceCurrency=CNY&version=1.0.0';
    return config
}, error => {
    // Do something with request error
    Message({
        message: error,
        type: 'error',
        duration: 3 * 1000
    })
    return Promise.reject(error);
})

// respone interceptor
axios.interceptors.response.use(
    response => {
        //如果是极验的接口，直接返回，不拦截
        if (response.request.responseURL.indexOf('/geetest') >= 0) {
            return response;
        }
        const res = response.data;
        if (res.code === store.state.errorCode.jwtOutTime) {
            //需要更新jwt-token
            window.localStorage.setItem('jwt-token',res.data.jwtToken);
            let reqConfig = response.config;
            return axios(reqConfig);
        }
        if (res.code === store.state.errorCode.jwtError || res.code === store.state.errorCode.notLogin) {
            store.dispatch('actions_loginOut').then(re => {
                // Message({
                //     message: res.msg,
                //     type: 'error',
                //     duration: 3 * 1000
                // });
                // if (window.location.hash === '#/') {
                //     // location.reload();// 为了重新实例化vue-router对象 避免bug
                // } else {
                //     window.location.hash = '#/';
                // }
				window.location.hash = '#/login';
            });
        } else {
            return response;
        }
    }, err => {
        // 检查是否有响应数据，如果有且包含innerMsg，则使用innerMsg作为错误信息
        if (err.response && err.response.data) {
            const responseData = err.response.data;
            if (responseData.innerMsg) {
                err.message = responseData.innerMsg;
            } else if (responseData.msg) {
                err.message = responseData.msg;
            }
        }

        // 请求超时， 重新请求
        let config = err.config;
        // If config does not exist or the retry option is not set, reject
        if(!config || !config.retry) return Promise.reject(err);

        // Set the variable for keeping track of the retry count
        config.__retryCount = config.__retryCount || 0;

        // Check if we've maxed out the total number of retries
        if(config.__retryCount >= config.retry) {
            // Reject with the error
            return Promise.reject(err);
        }

        // Increase the retry count
        config.__retryCount += 1;

        // Create new promise to handle exponential backoff
        let backoff = new Promise(function(resolve) {
            setTimeout(function() {
                resolve();
            }, config.retryDelay || 1);
        });

        // Return the promise in which recalls axios to retry the request
        return backoff.then(function() {
            return axios(config);
        });
    })

window.$axios = Vue.prototype.$axios = axios;
